import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Settings, Grid3X3, Shield, ShieldOff } from "lucide-react";
import { DeviceSidebar } from "./DeviceSidebar";
import { LevelBrowserCategoriesContent } from "./LevelBrowserCategoriesContent";
import { LevelBrowserWhitelistContent } from "./LevelBrowserWhitelistContent";
import { LevelBrowserBlacklistContent } from "./LevelBrowserBlacklistContent";
import { LevelBrowserSettingsContent } from "./LevelBrowserSettingsContent";

interface LevelBrowserTabProps {
  levelId: string;
}

export const LevelBrowserTab = ({ levelId }: LevelBrowserTabProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState("categories");

  // Restore active section from URL params
  useEffect(() => {
    const section = searchParams.get('browserSection');
    if (section && ['categories', 'whitelist', 'blacklist', 'settings'].includes(section)) {
      setActiveSection(section);
    }
  }, [searchParams]);

  // Save active section to URL params
  const handleSectionChange = (section: string) => {
    setActiveSection(section);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('browserSection', section);
    setSearchParams(newSearchParams);
  };

  const sidebarItems = [
    { id: "categories", label: "Categories", icon: Grid3X3 },
    { id: "whitelist", label: "White List", icon: Shield },
    { id: "blacklist", label: "Black List", icon: ShieldOff },
    { id: "settings", label: "Settings", icon: Settings },
  ];

  const renderContent = () => {
    switch (activeSection) {
      case "categories":
        return <LevelBrowserCategoriesContent levelId={levelId} />;
      case "whitelist":
        return <LevelBrowserWhitelistContent levelId={levelId} />;
      case "blacklist":
        return <LevelBrowserBlacklistContent levelId={levelId} />;
      case "settings":
        return <LevelBrowserSettingsContent levelId={levelId} />;
      default:
        return <LevelBrowserCategoriesContent levelId={levelId} />;
    }
  };

  return (
    <div className="flex h-full">
      <DeviceSidebar
        title="Browser Management"
        items={sidebarItems}
        activeSection={activeSection}
        onSectionChange={handleSectionChange}
      />
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-y-auto">
          <div className="p-6">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};